(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["discountbox-address-prestep"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const modal = document.getElementById('dbx-address-modal');
    if (!modal || modal.dataset.initialized === 'true') return;
    modal.dataset.initialized = 'true';

    const form = modal.querySelector('#dbx-address-form');
    const provinceSelect = modal.querySelector('#dbx-province');
    const cityInput = modal.querySelector('#dbx-city');
    const cityListbox = modal.querySelector('#dbx-city-listbox');
    const areaInput = modal.querySelector('#dbx-area');
    const areaListbox = modal.querySelector('#dbx-area-listbox');
    const statusBox = modal.querySelector('#dbx-address-status');
    const errorBox = modal.querySelector('#dbx-address-error');
    const submitButton = form.querySelector('[type="submit"]');
    const defaultSubmitLabel = 'SAVE & CONTINUE';
    const locationUrl = modal.dataset.locationUrl;
    const maxRenderedOptions = 5000;

    let dataset = null;
    let selectedProvince = null;
    let selectedCity = null;
    let selectedArea = null;
    let pendingCheckoutUrl = '/checkout';
    let lastCheckoutIntercept = 0;
    let optionsByInput = new WeakMap();
    let activeIndexByInput = new WeakMap();

    const normalize = (value) =>
      String(value || '')
        .normalize('NFKC')
        .replace(/[\u200B-\u200D\u2060\uFEFF]/g, '')
        .trim()
        .replace(/\s+/g, ' ')
        .toLocaleLowerCase('en');

    const optionNode = (value, label) => {
      const node = document.createElement('option');
      node.value = value;
      node.textContent = label || value;
      return node;
    };

    const showError = (message) => {
      errorBox.textContent = message;
      errorBox.hidden = !message;
    };

    const setStatus = (message) => {
      statusBox.textContent = message;
      statusBox.hidden = !message;
    };

    const resetSubmitState = () => {
      submitButton.textContent = defaultSubmitLabel;
      submitButton.disabled = !dataset;
    };

    const fetchWithTimeout = (url, options = {}, timeout = 15000) => {
      const controller = new AbortController();
      const timer = window.setTimeout(() => controller.abort(), timeout);
      return fetch(url, { ...options, signal: controller.signal }).finally(() => {
        window.clearTimeout(timer);
      });
    };

    const hideListbox = (input, listbox) => {
      listbox.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
      activeIndexByInput.set(input, -1);
    };

    const clearArea = () => {
      selectedArea = null;
      areaInput.value = '';
      areaInput.disabled = !selectedCity;
      hideListbox(areaInput, areaListbox);
    };

    const clearCity = () => {
      selectedCity = null;
      cityInput.value = '';
      cityInput.disabled = !selectedProvince;
      hideListbox(cityInput, cityListbox);
      clearArea();
      areaInput.disabled = true;
    };

    const selectCity = (record) => {
      selectedCity = record;
      cityInput.value = record.name;
      clearArea();
      areaInput.disabled = false;
      hideListbox(cityInput, cityListbox);
      areaInput.focus();
    };

    const selectArea = (record) => {
      selectedArea = record;
      areaInput.value = record.name;
      hideListbox(areaInput, areaListbox);
    };

    const renderListbox = (input, listbox, records, selectRecord, emptyMessage) => {
      const query = normalize(input.value);
      const matches = [];
      for (const record of records) {
        if (!query || normalize(record.name).includes(query)) {
          matches.push(record);
          if (matches.length >= maxRenderedOptions) break;
        }
      }

      listbox.replaceChildren();
      optionsByInput.set(input, matches);
      activeIndexByInput.set(input, -1);

      if (!matches.length) {
        const message = document.createElement('span');
        message.className = 'dbx-listbox-message';
        message.textContent = emptyMessage;
        listbox.appendChild(message);
      } else {
        matches.forEach((record, index) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'dbx-listbox-option';
          button.id = `${input.id}-option-${index}`;
          button.setAttribute('role', 'option');
          button.setAttribute('aria-selected', 'false');
          button.textContent = record.name;
          button.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            selectRecord(record);
          });
          listbox.appendChild(button);
        });
      }

      listbox.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    };

    const setActiveOption = (input, listbox, direction) => {
      const options = [...listbox.querySelectorAll('[role="option"]')];
      if (!options.length) return;
      let activeIndex = activeIndexByInput.get(input) ?? -1;
      activeIndex = Math.max(0, Math.min(options.length - 1, activeIndex + direction));
      activeIndexByInput.set(input, activeIndex);
      options.forEach((node, index) => node.setAttribute('aria-selected', index === activeIndex ? 'true' : 'false'));
      input.setAttribute('aria-activedescendant', options[activeIndex].id);
      options[activeIndex].scrollIntoView({ block: 'nearest' });
    };

    const bindCombobox = (input, listbox, getRecords, selectRecord, emptyMessage) => {
      const render = () => renderListbox(input, listbox, getRecords(), selectRecord, emptyMessage);

      input.addEventListener('focus', render);
      input.addEventListener('input', () => {
        if (input === cityInput) {
          if (!selectedCity || normalize(input.value) !== normalize(selectedCity.name)) {
            selectedCity = null;
            clearArea();
            areaInput.disabled = true;
          }
        } else if (!selectedArea || normalize(input.value) !== normalize(selectedArea.name)) {
          selectedArea = null;
        }
        render();
      });
      input.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowDown') {
          event.preventDefault();
          if (listbox.hidden) render();
          setActiveOption(input, listbox, 1);
        } else if (event.key === 'ArrowUp') {
          event.preventDefault();
          if (listbox.hidden) render();
          setActiveOption(input, listbox, -1);
        } else if (event.key === 'Enter' && !listbox.hidden) {
          const records = optionsByInput.get(input) || [];
          const activeIndex = activeIndexByInput.get(input) ?? -1;
          if (activeIndex >= 0 && records[activeIndex]) {
            event.preventDefault();
            selectRecord(records[activeIndex]);
          }
        } else if (event.key === 'Escape') {
          hideListbox(input, listbox);
        }
      });
      input.addEventListener('blur', (event) => {
        const nextTarget = event.relatedTarget;
        if (nextTarget instanceof Element && listbox.contains(nextTarget)) return;

        window.setTimeout(() => {
          const activeTarget = document.activeElement;
          if (activeTarget instanceof Element && listbox.contains(activeTarget)) return;
          hideListbox(input, listbox);
        }, 250);
      });
    };

    const loadLocations = async () => {
      try {
        const response = await fetch(locationUrl, { credentials: 'same-origin' });
        if (!response.ok) throw new Error(`Location data request failed: ${response.status}`);
        dataset = await response.json();
        if (!dataset || !Array.isArray(dataset.provinces) || !dataset.l4Lookup) {
          throw new Error('Location data has an invalid schema');
        }

        provinceSelect.replaceChildren(optionNode('', 'Please choose your province'));
        dataset.provinces.forEach((province) => {
          provinceSelect.appendChild(optionNode(province.id, province.name));
        });
        provinceSelect.disabled = false;
        submitButton.disabled = false;
        setStatus('');
      } catch (error) {
        provinceSelect.replaceChildren(optionNode('', 'Location data unavailable'));
        provinceSelect.disabled = true;
        submitButton.disabled = true;
        setStatus('');
        showError('Location data load nahi ho saka. Please page refresh karke dobara try karein.');
        console.error('[DiscountBox address]', error);
      }
    };

    const validateHierarchy = () => {
      if (!dataset || !selectedProvince || !selectedCity || !selectedArea) return null;
      const hierarchy = dataset.l4Lookup[selectedArea.id];
      if (!hierarchy) return null;
      const valid =
        normalize(hierarchy.province) === normalize(selectedProvince.name) &&
        normalize(hierarchy.baseCity) === normalize(selectedCity.baseCity) &&
        normalize(hierarchy.l3City) === normalize(selectedCity.name) &&
        normalize(hierarchy.l4Area) === normalize(selectedArea.name);
      return valid ? hierarchy : null;
    };

    const normalizePhone = (phone) => {
      const digits = String(phone || '').replace(/\D/g, '');
      if (digits.startsWith('0092')) return `+92${digits.slice(4)}`;
      if (digits.startsWith('92')) return `+${digits}`;
      if (digits.startsWith('0')) return `+92${digits.slice(1)}`;
      if (digits.length === 10) return `+92${digits}`;
      return String(phone || '').trim();
    };

    const splitFullName = (fullName) => {
      const parts = String(fullName || '').trim().split(/\s+/).filter(Boolean);
      if (!parts.length) return { firstName: '', lastName: '' };
      if (parts.length === 1) return { firstName: parts[0], lastName: parts[0] };
      return {
        firstName: parts.slice(0, -1).join(' '),
        lastName: parts.at(-1)
      };
    };

    const readableAddress = (parts) => {
      const result = [];
      parts.forEach((part) => {
        const value = String(part || '').trim();
        if (!value) return;
        const key = normalize(value);
        const duplicated = result.some((existing) => {
          const existingKey = normalize(existing);
          return existingKey === key || existingKey.includes(key);
        });
        if (!duplicated) result.push(value);
      });
      return result.join(', ');
    };

    const addCheckoutParams = (url, formData, hierarchy, attributes) => {
      const name = splitFullName(formData.get('full_name'));
      const phone = normalizePhone(formData.get('phone'));
      const address1 = readableAddress([
        formData.get('street'),
        formData.get('address_note'),
        hierarchy.l4Area
      ]);
      const address2 = readableAddress([
        formData.get('landmark'),
        hierarchy.l3City,
        hierarchy.province
      ]);

      url.searchParams.set('checkout[shipping_address][first_name]', name.firstName);
      url.searchParams.set('checkout[shipping_address][last_name]', name.lastName);
      url.searchParams.set('checkout[phone]', phone);
      url.searchParams.set('checkout[shipping_address][phone]', phone);
      url.searchParams.set('checkout[shipping_address][address1]', address1 || attributes['Complete Customer Address']);
      url.searchParams.set('checkout[shipping_address][address2]', address2);
      url.searchParams.set('checkout[shipping_address][city]', hierarchy.baseCity);
      url.searchParams.set('checkout[shipping_address][province]', hierarchy.province);
      url.searchParams.set('checkout[shipping_address][country]', 'Pakistan');
      url.searchParams.set('checkout[shipping_address][zip]', '00000');
      return `${url.pathname}${url.search}`;
    };

    const buildCartPermalink = async (formData, hierarchy, attributes) => {
      const response = await fetchWithTimeout('/cart.js', {
        method: 'GET',
        headers: { Accept: 'application/json' }
      });
      if (!response.ok) throw new Error('Cart read failed');
      const cart = await response.json();
      const items = (cart.items || [])
        .map((item) => `${item.variant_id}:${item.quantity}`)
        .filter(Boolean);
      const url = new URL(items.length ? `/cart/${items.join(',')}` : pendingCheckoutUrl, window.location.origin);
      return addCheckoutParams(url, formData, hierarchy, attributes);
    };

    const closeThemeCartDrawer = () => {
      const selectors = [
        'cart-drawer',
        'cart-notification',
        '#CartDrawer',
        '[id*="CartDrawer"]',
        '.cart-drawer',
        '.cart-notification',
        '[class*="cart-drawer"]',
        '[class*="cart-notification"]',
        'dialog[open]'
      ];

      selectors.forEach((selector) => {
        document.querySelectorAll(selector).forEach((drawer) => {
          if (drawer === modal || modal.contains(drawer)) return;
          if (typeof drawer.close === 'function' && drawer.open) {
            try {
              drawer.close();
            } catch (error) {
              console.debug('[DiscountBox address] Drawer close skipped', error);
            }
          }
          drawer.removeAttribute('open');
          drawer.removeAttribute('active');
          drawer.removeAttribute('aria-modal');
          drawer.setAttribute('aria-hidden', 'true');
          drawer.classList.remove('active', 'animate', 'menu-opening', 'is-open', 'open');
          drawer.style.visibility = 'hidden';
          drawer.style.pointerEvents = 'none';
        });
      });

      document.querySelectorAll('[aria-controls*="CartDrawer"], [aria-controls*="cart-drawer"]').forEach((button) => {
        button.setAttribute('aria-expanded', 'false');
      });
    };

    const openModal = (checkoutUrl) => {
      pendingCheckoutUrl = checkoutUrl || '/checkout';
      if (modal.parentNode !== document.body) document.body.appendChild(modal);
      closeThemeCartDrawer();
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('dbx-address-locked');
      window.setTimeout(() => form.elements.full_name.focus(), 0);
    };

    const closeModal = () => {
      hideListbox(cityInput, cityListbox);
      hideListbox(areaInput, areaListbox);
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('dbx-address-locked');
    };

    const interceptEvent = (event) => {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation?.();
    };

    const isCheckoutTrigger = (target) =>
      target instanceof Element
        ? target.closest('button[name="checkout"], input[name="checkout"], a[href*="/checkout"]')
        : null;

    const handleCheckoutTrigger = (event) => {
      const trigger = isCheckoutTrigger(event.target);
      if (!trigger) return;
      interceptEvent(event);
      lastCheckoutIntercept = Date.now();
      openModal(trigger.href || '/checkout');
    };

    bindCombobox(
      cityInput,
      cityListbox,
      () => selectedProvince?.l3Cities || [],
      selectCity,
      'No city available'
    );
    bindCombobox(
      areaInput,
      areaListbox,
      () => selectedCity?.areas || [],
      selectArea,
      'No area available'
    );

    provinceSelect.addEventListener('change', () => {
      selectedProvince =
        dataset?.provinces.find((province) => province.id === provinceSelect.value) || null;
      clearCity();
      cityInput.disabled = !selectedProvince;
      if (selectedProvince) cityInput.focus();
    });

    document.addEventListener('pointerdown', handleCheckoutTrigger, true);
    document.addEventListener('touchstart', handleCheckoutTrigger, true);
    document.addEventListener(
      'click',
      (event) => {
        if (Date.now() - lastCheckoutIntercept < 900) {
          if (isCheckoutTrigger(event.target)) interceptEvent(event);
          return;
        }
        handleCheckoutTrigger(event);
      },
      true
    );

    document.addEventListener(
      'submit',
      (event) => {
        const checkoutForm = event.target;
        if (!(checkoutForm instanceof HTMLFormElement) || checkoutForm === form) return;
        const action = (checkoutForm.getAttribute('action') || '').toLocaleLowerCase('en');
        const hasCheckoutButton = checkoutForm.querySelector('button[name="checkout"], input[name="checkout"]');
        if (!action.includes('/cart') && !hasCheckoutButton) return;
        if (event.submitter && event.submitter.name !== 'checkout') return;
        interceptEvent(event);
        openModal('/checkout');
      },
      true
    );

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      showError('');

      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      if (!selectedCity || normalize(cityInput.value) !== normalize(selectedCity.name)) {
        showError('Please choose a valid city from the list.');
        cityInput.focus();
        return;
      }

      if (!selectedArea || normalize(areaInput.value) !== normalize(selectedArea.name)) {
        showError('Please choose a valid area from the list.');
        areaInput.focus();
        return;
      }

      const hierarchy = validateHierarchy();
      if (!hierarchy) {
        showError('The selected Province, City and Area combination is invalid. Please select it again.');
        provinceSelect.focus();
        return;
      }

      const formData = new FormData(form);
      const completeAddress = readableAddress([
        formData.get('street'),
        formData.get('address_note'),
        formData.get('landmark'),
        hierarchy.l4Area,
        hierarchy.l3City,
        hierarchy.baseCity,
        hierarchy.province,
        'Pakistan'
      ]);
      const addressLabel = formData.get('address_type') || '';
      const attributes = {
        'Delivery Province': hierarchy.province,
        'Base City': hierarchy.baseCity,
        'Selected City / L3': hierarchy.l3City,
        'Selected Area / L4': hierarchy.l4Area,
        'Address Label': addressLabel,
        'Complete Customer Address': completeAddress,
        'Location Dataset Version': String(dataset.version),
        'DBX Full Name': formData.get('full_name') || '',
        'DBX Phone': normalizePhone(formData.get('phone')),
        'DBX Province': hierarchy.province,
        'DBX City': hierarchy.baseCity,
        'DBX Area': hierarchy.l4Area,
        'DBX Street': formData.get('street') || '',
        'DBX Landmark': formData.get('landmark') || '',
        'DBX Address Note': formData.get('address_note') || '',
        'DBX Address Type': addressLabel,
        'DBX Complete Address': completeAddress
      };

      submitButton.disabled = true;
      submitButton.textContent = 'SAVING…';
      try {
        const response = await fetchWithTimeout('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            attributes,
            note: `Delivery address: ${completeAddress}`
          })
        });
        if (!response.ok) throw new Error('Cart update failed');
        const checkoutUrl = await buildCartPermalink(formData, hierarchy, attributes);
        window.location.href = checkoutUrl;
      } catch (error) {
        resetSubmitState();
        showError('Address save nahi ho saka. Please dobara try karein.');
        console.error('[DiscountBox address]', error);
      }
    });

    modal.addEventListener('click', (event) => {
      if (event.target instanceof Element && event.target.hasAttribute('data-dbx-close')) closeModal();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && modal.getAttribute('aria-hidden') === 'false') closeModal();
    });

    window.addEventListener('pagehide', resetSubmitState);
    window.addEventListener('pageshow', resetSubmitState);

    submitButton.disabled = true;
    loadLocations();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
